import classNames from 'classnames';
import {
  forwardRef,
  memo,
  type PropsWithChildren,
  type CSSProperties,
} from 'react';

export type BodyProps = PropsWithChildren<{
  className?: string;
  size: 'small' | 'base' | 'medium' | 'large';
  style?: CSSProperties;
}>;

const sizeClasses: Record<BodyProps['size'], string> = {
  small: 'tw:text-body-small',
  base: 'tw:text-body-base',
  medium: 'tw:text-body-medium',
  large: 'tw:text-body-large',
};

export const Body = memo(forwardRef<HTMLDivElement, BodyProps>(({
  children,
  className,
  size,
  style: styleProp,
}, ref) => {
  const bodyClassName = classNames('tw:leading-body tw:tracking-body', sizeClasses[size], className);

  return (
    <div
      className={bodyClassName}
      ref={ref}
      style={styleProp}>
      {children}
    </div>
  );
}));

Body.displayName = 'Body';
